import { BaseLayout } from '@/components/layout/BaseLayout'

export function SettingsPage() {
  return (
    <BaseLayout>
      <div className="p-8">
        <h1 className="text-3xl font-bold mb-4">Settings</h1>
        <p className="text-muted-foreground">Configure your store settings</p>
      </div>
    </BaseLayout>
  )
}
